"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY = exports.BREAKPOINT_HORIZONTAL_SIDEPANEL = void 0;
/**
 * Breakpoint when a sidepanel (PersonalMenu) is displayed on the Online pages.
 * Breakpoint is also consumed in `@ori-appshell/layouts` and `@ori/footer`.
 **/
const BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY = exports.BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY = 1025;
/** Breakpoint when a sidepanel (PersonalMenu) is displayed on the AppShell pages. */
const BREAKPOINT_HORIZONTAL_SIDEPANEL = exports.BREAKPOINT_HORIZONTAL_SIDEPANEL = 'md';